import { saveAs } from 'file-saver';

export default class FileUtil
{
    /**
     * Exports to a file with the specified name, extension (e.g. '.docx' or '.csv') and data.
     */
    public static exportToFile(fileName : string, fileExtension : string, fileData : string | Blob)
    {
        // TODO: should probably be handled with regex
        let sanitizedName = 
            fileName
                .replace('/', '_')
                .replace('.', '_')
                .replace('*', '_')
                .replace('[', '_')
                .replace(':', '_')
                .replace('|', '_')
                .replace(',', '_')
                .replace('=', '_')
                .replace(']', '_')
                .replace(';', '_')
                .replace('\\', '_');
        
        sanitizedName += fileExtension;

        console.log(`Downloading: ${sanitizedName}`);

        if (!(fileData instanceof Blob))
        {
            fileData = new Blob([fileData]);
        }

        saveAs(fileData, sanitizedName);
    }
}